module.exports = __webpack_public_path__ + "img/logo.60387596.png";